import * as React from 'react';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import { connect, Verification } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import ModulesRoute from './Modules.Route';
import UIWxLogin from './UI.WxLogin';
import JSString from 'kts-scaffold-framework/utils/kit/JSString';
import { loginUrl } from 'kts-platform-frame/entry/configUtils';

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据 */
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class Login extends ModulesBasic<IProps, ModulesState> {

    public state: ModulesState = new ModulesState();

    private code = JSString.getQueryString(window.location.search, 'code');

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    /*************************************登录页面已经迁移至kts-login中*******************************/
    render() {
        if (Verification.instance.isLogIn()) {
            return (
                <ModulesRoot action={ModulesAction}>
                    <div className={css.login} >
                        {
                            this.code
                                ? <UIWxLogin code={this.code} />
                                : ModulesRoute.getChildReact()
                        }
                    </div>
                </ModulesRoot>
            );
        }
        else {
            return null;
        }
    }
}




// WEBPACK FOOTER //
// ./src/display/modules/Home/Login/index.tsx